var map = {
	"./american-football-311817_640.png": 851,
	"./carrot-5982724_640.png": 729,
	"./donut-pile-search-and-find-codesweetly.svg": 207,
	"./french-fries-155679_640.png": 42,
	"./hamburger-31775_640.png": 37,
	"./pngkey.com-pineapple-clipart-png-9605931.png": 984,
	"./pngkey.com-pizza-png-53164.png": 436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;